/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PhysioItem from './physio-item';
import PhysioItemDetail from './physio-item-detail';
import PhysioItemUpdate from './physio-item-update';
import PhysioItemDeleteDialog from './physio-item-delete-dialog';

const PhysioItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PhysioItem />} />
    <Route path="new" element={<PhysioItemUpdate />} />
    <Route path=":id">
      <Route index element={<PhysioItemDetail />} />
      <Route path="edit" element={<PhysioItemUpdate />} />
      <Route path="delete" element={<PhysioItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PhysioItemRoutes;
